import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';

// Import mapped SVG icons.
import AsphaltedIcon from 'assets/icons/AsphaltedIcon';
import BreakfastIcon from 'assets/icons/BreakfastIcon';
import CallIcon from 'assets/icons/CallIcon';
import CarIcon from 'assets/icons/CarIcon';
import CarIndoorIcon from 'assets/icons/CarIndoorIcon';
import CarOutdoorIcon from 'assets/icons/CarOutdoorIcon';
import Clock6Icon from 'assets/icons/Clock6Icon';
import Clock7Icon from 'assets/icons/Clock7Icon';
import Clock8Icon from 'assets/icons/Clock8Icon';
import DoubleRoomIcon from 'assets/icons/DoubleRoomIcon';
import EnclosedIcon from 'assets/icons/EnclosedIcon';
import EntryCodeIcon from 'assets/icons/EntryCodeIcon';
import KeyGiveIcon from 'assets/icons/KeyGiveIcon';
import KeyKeepIcon from 'assets/icons/KeyKeepIcon';
import KeyKeepPaidIcon from 'assets/icons/KeyKeepPaidIcon';
import LicensePlateIcon from 'assets/icons/LicensePlateIcon';
import LuggageIcon from 'assets/icons/LuggageIcon';
import LocationPinIcon from 'assets/icons/LocationPinIcon';
import MaxDurationIcon from 'assets/icons/MaxDurationIcon';
import MeetGreetIcon from 'assets/icons/MeetGreetIcon';
import MinivanIcon from 'assets/icons/MinivanIcon';
import NoShuttleIcon from 'assets/icons/NoShuttleIcon';
import Open247Icon from 'assets/icons/Open247Icon';
import Open4Icon from 'assets/icons/Open4Icon';
import Open5Icon from 'assets/icons/Open5Icon';
import ParkingTicketIcon from 'assets/icons/ParkingTicketIcon';
import PluginChargingIcon from 'assets/icons/PluginChargingIcon';
import SecurityCamIcon from 'assets/icons/SecurityCamIcon';
import SecurityIcon from 'assets/icons/SecurityIcon';
import SedanIcon from 'assets/icons/SedanIcon';
import ShuttleIcon from 'assets/icons/ShuttleIcon';
import SmsIcon from 'assets/icons/SmsIcon';
import TaxiElectricalIcon from 'assets/icons/TaxiElectricalIcon';
import TaxiIcon from 'assets/icons/TaxiIcon';
import TeslaChargingIcon from 'assets/icons/TeslaChargingIcon';
import TripleRoomIcon from 'assets/icons/TripleRoomIcon';
import UnpavedIcon from 'assets/icons/UnpavedIcon';
import WaitingRoomIcon from 'assets/icons/WaitingRoomIcon';
import WheelchairIcon from 'assets/icons/WheelchairIcon';

// Map icons to property ID's.
const iconMapping = {
    4: KeyKeepIcon,
    5: KeyGiveIcon,
    6: AsphaltedIcon,
    7: EnclosedIcon,
    8: Open247Icon,
    9: CarIndoorIcon,
    10: CarOutdoorIcon,
    11: SecurityIcon,
    12: SecurityCamIcon,
    13: LicensePlateIcon,
    14: EntryCodeIcon,
    15: WaitingRoomIcon,
    16: ShuttleIcon,
    17: NoShuttleIcon,
    18: ShuttleIcon,
    19: TeslaChargingIcon,
    20: PluginChargingIcon,
    21: ShuttleIcon,
    22: CarIcon,
    23: MinivanIcon,
    24: SedanIcon,
    25: TaxiElectricalIcon,
    26: SmsIcon,
    27: CallIcon,
    28: CallIcon,
    29: MeetGreetIcon,
    31: UnpavedIcon,
    32: Open4Icon,
    33: Open5Icon,
    34: DoubleRoomIcon,
    35: TripleRoomIcon,
    36: BreakfastIcon,
    37: KeyKeepPaidIcon,
    45: WheelchairIcon,
    47: Clock7Icon,
    48: LuggageIcon,
    49: LuggageIcon,
    50: LuggageIcon,
    51: LuggageIcon,
    52: LuggageIcon,
    53: ParkingTicketIcon,
    54: LocationPinIcon,
    55: LocationPinIcon,
    56: Clock8Icon,
    57: ShuttleIcon,
    59: CallIcon,
    61: Clock6Icon,
    63: TaxiIcon,
    64: LocationPinIcon,
    126: MaxDurationIcon,
};

export const hasIcon = (id) => {
    return !!iconMapping[id];
};

const PropertyIcon = (props) => {
    const { id } = props;

    if (!id) {
        return null;
    }

    if (!hasIcon(id)) {
        return null;
    }

    const Icon = iconMapping[id];

    return (
        <IconButton
            style={ props.style }
            tooltip={ props.tooltip && props.tooltipName }
            tooltipPosition={ props.tooltip && props.tooltipPosition }
            tooltipStyles={ props.tooltip && props.tooltipStyles }
            disabled={ props.disabled }
        >
            <Icon />
        </IconButton>
    );
};

PropertyIcon.defaultProps = {
    disabled: false,
    style: {},
    tooltip: false,
};

PropertyIcon.propTypes = {
    disabled: PropTypes.bool,
    id: PropTypes.number,
    style: PropTypes.object,
    tooltip: PropTypes.bool,
    tooltipName: PropTypes.string,
    tooltipPosition: PropTypes.string,
    tooltipStyles: PropTypes.object,
};

PropertyIcon.defaultProps = {
    addLabel: true,
    record: {},
};

export default PropertyIcon;



// WEBPACK FOOTER //
// ./src/components/field/PropertyIcon.js